import { ChangeDetectionStrategy, Component, inject, OnInit } from "@angular/core";
import { Router } from "@angular/router";

import { SnackbarService } from "../../components/snackbar/snackbar.service";
import { NavigationService } from "../../shared/services/navigation.service";
import { AuthService } from "../auth.service";

@Component({
    selector: "app-auth-callback",
    template: "",
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true
})
export class AuthCallbackComponent implements OnInit {
    private readonly authService = inject(AuthService);
    private readonly navigationService = inject(NavigationService);
    private readonly router = inject(Router);
    private readonly snackbarService = inject(SnackbarService);

    ngOnInit(): void {
        // Amplify processes the OAuth callback URL during Amplify.configure(), which runs
        // at app bootstrap before any component is mounted. By the time ngOnInit runs,
        // the session is already established (or failed), so we can read it directly via
        // loadSession() instead of waiting on a Hub event that has already fired.
        this.authService.loadSession().then(() => {
            if (this.authService.isAuthenticated()) {
                return this.router.navigate([this.navigationService.postLoginRoute()]);
            }

            this.snackbarService.show("Sign in could not be completed. Please try again.", "error");
            return this.router.navigate(["/login"]);
        });
    }
}
